import dictionary from './en.json'

/** @deprecated Import from ./en.json instead. */
export default dictionary
